import { PDFDocument } from 'pdf-lib';
import fillablePdf from '../assets/pdf/Paysign-Post-Transaction-Claim-Fillable-PDF-20241122v1.pdf';
import { removeWhiteBackground } from './util';

function isPng(buffer) {
  const uint = new Uint8Array(buffer);
  return uint[0] === 0x89 && uint[1] === 0x50 && uint[2] === 0x4E && uint[3] === 0x47;
}

async function embedSignatureImage(pdfDoc, imageBytes) {
  if (isPng(imageBytes)) {
    return await pdfDoc.embedPng(imageBytes);
  } else {
    return await pdfDoc.embedJpg(imageBytes);
  }
}

export const fillPdf = async (pdfFormData) => {
  const existingPdfBytes = await fetch(fillablePdf).then(res => res.arrayBuffer());
  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  const form = pdfDoc.getForm();
  const pages = pdfDoc.getPages();
  const firstPage = pages[0];

  // Fill fields
  Object.entries(pdfFormData).forEach(([fieldName, value]) => {
    try {
      const field = form.getField(fieldName);
      if (!field) {
        console.warn(`Field not found: ${fieldName}`);
        return;
      }
      if (fieldName.includes('Check Box')) {
        if (value === true || value === 'Yes' || value === 'On' || value === '1') {
          field.check();
        } else {
          field.uncheck();
        }
      } else {
        field.setText(value || '');
      }
    } catch (err) {
      console.error(`Error filling field ${fieldName}:`, err);
    }
  });

  const signatureUrl = pdfFormData["Signature19_es_:signer:signature"];
  if (signatureUrl) {
    try {
      const imageBytesTransparent = await removeWhiteBackground(signatureUrl); // Use canvas function
      const signatureImage = await pdfDoc.embedPng(imageBytesTransparent);

      const sigField = form.getField("Signature19_es_:signer:signature");
      const widgets = sigField.acroField.getWidgets();

      if (widgets.length > 0 && typeof widgets[0].getRectangle === 'function') {
        const rect = widgets[0].getRectangle();

        // Original field position and size
        const origX = rect?.x ?? 100;
        const origY = rect?.y ?? 150;
        const origWidth = rect?.width ?? 120;
        const origHeight = rect?.height ?? 40;

        // Scale factor for bigger image (1 = original size)
        const scaleFactor = 2;

        // Calculate new width/height with scale factor, keeping aspect ratio
        const { width: imgWidth, height: imgHeight } = signatureImage.size();
        let newWidth = origWidth * scaleFactor;
        let newHeight = (imgHeight / imgWidth) * newWidth;

        // If scaled height is bigger than field height * scaleFactor, adjust accordingly to keep ratio
        if (newHeight > origHeight * scaleFactor) {
          newHeight = origHeight * scaleFactor;
          newWidth = (imgWidth / imgHeight) * newHeight;
        }

        // Center the image inside the original rectangle area (with scaling)
        const x = origX + (origWidth - newWidth) / 2;
        const y = origY + (origHeight - newHeight) / 2;

        // Clear any existing text in the field
        sigField.setText('');

        // Draw the scaled image
        firstPage.drawImage(signatureImage, {
          x,
          y,
          width: newWidth,
          height: newHeight,
        });
      } else {
        console.warn("Signature field widget or rectangle not available. Using fallback.");
        const { width, height } = signatureImage.scale(1.5);
        firstPage.drawImage(signatureImage, {
          x: 100,
          y: 150,
          width,
          height,
        });
      }
    } catch (err) {
      console.error("Failed to embed signature image:", err);
    }
  }

  // Optional: flatten the form to make it non-editable
  form.flatten();

  const pdfBytes = await pdfDoc.save();
  const blob = new Blob([pdfBytes], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);

  return url;
};